import React, {Component} from 'react';
import {Modal, Button, Row, Col}  from 'react-bootstrap'
import SecondServer from '../database/SecondServer'
import FormFactory from '../FormData/FormFactory';
import {promisePerms} from '../Report/DataHelpers'
import {permitted} from '../Overview/SitePerms'
import GrantRequest from '../Grants/RequestDialog'

import '../Report/report-header.css'
import '../Report/Controls/massedit.css'
import '../commoninputs.css'
import '../Sites/siteadd.css'
import "./SiteListEditModal.css";
import { siteAccessCode, grantAccessCode } from '../database/apiv2SiteAccessor';

export default class SiteListEditModal extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      errMsg: null,
      rerender: 0,
      grantNeeded: false,
    }
    this.siteAttribs = ["name", "access_code", "note"];
    this.validations = {"name": true, "access_code": true};
    this.handleClose = this.handleClose.bind(this);
    this.validate = this.validate.bind(this);
    this.validateAndMoveOn = this.validateAndMoveOn.bind(this);
    this.ff = new FormFactory()
  }

  componentDidMount() {
    this.initState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.opened !== this.props?.opened)
      this.initState();
  }

  initState () {
    this.ff.init()
    this.setState ({errMsg: null, grantNeeded: false})
    this.validations = {"name": true, "access_code": true};
  }
  
  async permissions() {
    let ss = new SecondServer(this.props);
    const field = this.ff.findChange('access_code');
    const perms = await promisePerms(ss, field.value)
    return perms
  }

  async saveChanges() {
    const url = "/tehama/site-list-server?&node_id=" + this.props.nodeIdForEdit;
    const ss = new SecondServer(this.props);
    let saveObj = this.ff.jsonifyInputs(this.siteAttribs);
    await ss.apiSaveData(url, saveObj);
    const msg = ss.getErrorMsg();
    this.setState ( {errMsg: msg } );
    return msg
  }

  async handleClose() {
    this.props.hide();
    this.initState();
  }

  handleChange = event => {
    this.ff.handleChange(event);
    this.setState ({rerender: this.state.rerender+1})
  }
  
  validate () {
    this.validations['name'] = !this.ff.isBlank('name');
    if (!this.validations['name']) {
      return "Site name cannot be blank"
    }

    let fieldName = 'access_code'
    this.validations[fieldName] = true;
    let field = this.ff.findChange(fieldName);
    if (!field || !field?.value) {
      this.validations[fieldName] = false;
      return "Access code cannot be blank"
    }
    field.value = field?.value.replace(/\s/g,'')
    const re = /[0-9]{11}/g;
    if(!re.test(field?.value)) {
      this.validations[fieldName] = false;
      return "Access code should be 11 digits";
    }
    //if (this.isSiteCached(field.value))
      //return "You already have access to this site"

    return null;
  }
  
  isSiteCached(siteid) {
    if (this.props?.sites?.some(site => siteid === siteAccessCode(site)))
      return true;
    return (this.props?.grants?.some(grant => siteid === grantAccessCode(grant)))
  }

  async moveOn () {
    console.log(this.props.nodeIdForEdit)
    if (this.props.nodeIdForEdit == null){
      alert("Node ID is empty! Can't Save Changes.")
    } else{
      const err = await this.saveChanges();
      if (!err) {
        this.handleClose();

        if (this.props.onChange)
          this.props.onChange(this.state);
        
        window.location.reload(true);  
      }
    }
  }

  async validateAndMoveOn() {
    const msg = this.validate()
    if (msg) {
      this.setState({errMsg: msg})
      return;
    }
    const perms = await this.permissions();
    if (!permitted(perms?.data?.data)) {
      this.setState ({grantNeeded:true})
      return;
    }
    this.moveOn ()
  }
  
  renderHeader(title) {
    return (
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
    )    
  }
  
  spacerCol() {
    return(
      <Col md="1"></Col>
    )
  }

  inputBorder(valid) {
    return valid ? "input-ok" : "input-issue";
  }

  inputCommon (element, id, prompt) {
    return (
      <Col md="5" className="label-item">
        <label htmlFor={id}>{prompt}</label>
        {element}
      </Col>
    )
  }
  modalInput(id, prompt, opts) {
    const bcolor = this.inputBorder(opts?.valid??true);
    const prev_item = this.ff.findChange(id)
    const toDisplay = prev_item ? prev_item.value : ""//initialValue
    return (this.inputCommon (
        <input className={"compact-item "+bcolor} type="text" value={toDisplay} id={id} 
          size={opts?.inputSize??35} onChange={this.handleChange} readOnly={opts?.readOnly??false} />, 
          id, prompt
      )
    )
  }
  grantModal (state) {
    this.setState({grantNeeded: state})
    if (false === state)
      this.handleClose();
  }

  renderTab1() {
    if (this.props.show){
      this.ff.addInitialChange('name', this.props.siteListNameToEdit);
      this.ff.addInitialChange('access_code', this.props.accessCodeToEdit);
    }
    return(
      <Modal.Body className='body-indent'>
        <Row className='mt-5 modal-top-row '>
          {this.modalInput('name', 'Site Name', {valid: this.validations["name"]})}
          {this.spacerCol()}
          {this.modalInput('access_code', 'Access Code', 
            {valid: this.validations["access_code"], readOnly: true})}
        </Row>
      </Modal.Body>
    )
  }
  render() {
    const field = this.ff.findChange('access_code');
    const inject = field?.value

    if (this.state.grantNeeded) 
      return (<GrantRequest {...this.props} AC={inject} show={this.state.grantNeeded} hide={()=>this.grantModal(false)} /> );
    return(
      <Modal show={this.props.show} onHide={this.handleClose} size="lg" contentClassName="custom-modal"> 
        {this.renderHeader("Edit Site")}
        {this.renderTab1()}
        <Modal.Footer>
          <div className="modal-error">{this.state.errMsg}</div>
          <Button className="custom-std-btn" onClick={()=>this.handleClose()}>Cancel</Button>
          <Button className="custom-std-btn" onClick={()=>this.validateAndMoveOn()}>Save</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}
